import {
  CircularProgress,
  Collapse,
  Table, TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import {Add, ExpandLess, ExpandMore, Remove} from "@material-ui/icons";
import Divider from "@material-ui/core/Divider";
import BrokerDealerStatesContainer from "../../../../containers/admin/contacts/BrokerDealerStatesContainer";
import RegulatoryOrganizationsContainer from "../../../../containers/admin/contacts/RegulatoryOrganizationsContainer";
import RegistrationsRow from "../acordionRows/RegistrationsRow";
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));
const Registrations = (props) => {
  const classes = useStyles();
  const[regulatoryOrganizationsAccordion, setRegulatoryOrganizationsAccordion] = useState(false);
  const[brokerDealerStatesAccordion, setBrokerDealerStatesAccordion] = useState(false);
  const[investmentAdvisorStateAccordion, setInvestmentAdvisorStateAccordion] = useState(false);
  const [registrations, setRegistrations] = useState([]);
  const [status, setStatus] = useState('fetching');

  const {
    handleTabChange,
    tab,
    tabNumber,
    itemType,
    adminUserSession,
    accordion,
    contactId,
  } = props;

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${contactId}/registration`,
      {
        params: { entity_type: itemType },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { registrations, status } = response.data;

      setStatus(status);
      setRegistrations(registrations);
    });
  }, []);

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, tabNumber)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === tabNumber ? classes.tabActive : ''}`}>Registrations</Typography>
        {status !== 'fetched' ? <CircularProgress /> : ''}
        {tab === tabNumber ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === tabNumber}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            {accordion === 'investment'? (
              <div className={classes.registrationContainer}>
                <Typography variant='h5' className={classes.innerSectionTitle} onClick={() => setInvestmentAdvisorStateAccordion(!investmentAdvisorStateAccordion)}>
                  Investment Advisor State
                  <span className={classes.headerIconContainer}>{investmentAdvisorStateAccordion ? <Remove /> : <Add />}</span>
                </Typography>
                <Collapse in={investmentAdvisorStateAccordion} className={classes.innerSectionCollapse}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.inheritFontWeight}>regulator</TableCell>
                        <TableCell className={classes.inheritFontWeight}>registration</TableCell>
                        <TableCell className={classes.inheritFontWeight}>status</TableCell>
                        <TableCell className={classes.inheritFontWeight}>date</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <RegistrationsRow registrations={registrations}/>
                    </TableBody>
                  </Table>
                </Collapse>
              </div>
            ) :(
              <div className={classes.registrationContainer}>
                <Typography variant='h5' className={classes.innerSectionTitle}  onClick={() => setBrokerDealerStatesAccordion(!brokerDealerStatesAccordion)}>
                  Broker Dealer States
                  <span className={classes.headerIconContainer}>{brokerDealerStatesAccordion ? <Remove /> : <Add />}</span>
                </Typography>

                <Collapse in={brokerDealerStatesAccordion} className={classes.innerSectionCollapse}>
                  <BrokerDealerStatesContainer riaContactId={contactId} />
                </Collapse>
              </div>
            )}
            <Divider />
            <div className={classes.registrationContainer}>
              <Typography variant='h5' className={classes.innerSectionTitle} onClick={() => setRegulatoryOrganizationsAccordion(!regulatoryOrganizationsAccordion)}>
                Regulatory Organizations
                <span className={classes.headerIconContainer}>{regulatoryOrganizationsAccordion ? <Remove /> : <Add />}</span>
              </Typography>

              <Collapse in={regulatoryOrganizationsAccordion} className={classes.innerSectionCollapse}>
                <RegulatoryOrganizationsContainer riaContactId={contactId} />
              </Collapse>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default Registrations;